export default __webpack_public_path__ + "static/media/drivers.3a202766.svg";